import React, { FC } from 'react'
import { Flex } from '@components/gassan-ui'

const TripAdvisor: FC = () => {
  return (
    <Flex mt={{ _: '3.75rem', small: '7.5rem', xlarge: '9rem' }} justifyContent="center">
      <div id="TA_cdsratingsonlynarrow462" className="TA_cdsratingsonlynarrow">
        <ul id="t1wjjHFEMMLU" className="TA_links iTKJHUlXad">
          <li id="jbWSliiE" className="YipQG4M">
            <a
              target="_blank" // eslint-disable-line
              href="https://www.tripadvisor.nl/Attraction_Review-g188590-d1491782-Reviews-GASSAN-Amsterdam_North_Holland_Province.html"
            >
              <img
                src="https://www.tripadvisor.nl/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-18034-2.svg"
                alt="TripAdvisor"
                style={{ maxWidth: '115px' }}
              />
            </a>
          </li>
        </ul>
      </div>
      <script
        async
        src="https://www.jscache.com/wejs?wtype=cdsratingsonlynarrow&amp;uniq=462&amp;locationId=1491782&amp;lang=nl&amp;border=true&amp;display_version=2"
        data-loadtrk
        // @ts-ignore
        onLoad="this.loadtrk=true"
      />
    </Flex>
  )
}

export default TripAdvisor
